// extracted by mini-css-extract-plugin
export default {"tx":"_7cd9ace631","line":"b57ffd0cb6"};